import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/venuephotos/$venueSlug")({
  beforeLoad: ({ params, search }) => {
    // Build search object with tb=photo and preserve existing search params
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const searchObj: any = { tb: "photo" };

    // Preserve existing search params, stripping any surrounding quotes from values
    if (search && typeof search === "object") {
      Object.entries(search).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          // Remove surrounding quotes if present (handles",',`, and smart quotes)
          // const strValue = String(value).replace(/^["'`""'']+|["'`""'']+$/g,"");
          if (key === "cid" || key === "tid") {
            searchObj[key] = Number(value);
          } else {
            searchObj[key] = typeof value === "string" ? value : String(value);
          }
        }
      });
    }

    // 301 permanent redirect to venuedetails with tb=photo
    throw redirect({
      to: `/venuedetails/${params.venueSlug}`,
      search: searchObj,
      statusCode: 301,
    });
  },
});
